/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upload_Analyse_Flagged_ErrorInputs */

const en_upload_analyse_flagged_error = /** @type {(inputs: Upload_Analyse_Flagged_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The analysis found possible inconsistencies. You can continue and review the highlighted documents.`)
};

const pt_br2_upload_analyse_flagged_error = /** @type {(inputs: Upload_Analyse_Flagged_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A análise encontrou possíveis inconsistências. Você pode continuar e revisar os documentos destacados.`)
};

/**
* | output |
* | --- |
* | "The analysis found possible inconsistencies. You can continue and review the highlighted documents." |
*
* @param {Upload_Analyse_Flagged_ErrorInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const upload_analyse_flagged_error = /** @type {((inputs?: Upload_Analyse_Flagged_ErrorInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upload_Analyse_Flagged_ErrorInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_upload_analyse_flagged_error(inputs)
	return pt_br2_upload_analyse_flagged_error(inputs)
});